import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // baseUrl: 'https://partnersocialtest.intel.cn/apiTest',
    // HouUrl: 'https://partnersocialtest.intel.cn/APITest',
    // baseUrlAddress: 'https://partnersocialtest.intel.cn/test',
    // imgBaseUrl: 'https://partnersocialtest.intel.cn',
    // hostBackUrl: 'http://intel.chinabyte.com/app-private-intel-form/?form_id=', // 测试
    // listurl: 'https://partnersocialtest.intel.cn/files/test',
    // ulisturl1: 'https://partnersocialtest.intel.cn/apiTest/pc/qxsq/activity/exportByAdmin.do/?token=',
    // baseHref: 'https://partnersocialtest.intel.cn/reportTest/',

    baseUrl: "https://partnersocial.intel.cn/api",
    HouUrl: "https://partnersocial.intel.cn/API",
    baseUrlAddress: "https://partnersocial.intel.cn",
    imgBaseUrl: "https://partnersocial.intel.cn",
    hostBackUrl:"http://wx20aaf1189e47f6c6.mp.intel-social.com/addon/app-private-intel-form?a=index&form_id=", // 正式
    listurl: "https://partnersocial.intel.cn/files",
    ulisturl1:"https://partnersocial.intel.cn/api/pc/qxsq/activity/exportByAdmin.do/?token=",
    baseHref: "https://partnersocial.intel.cn/report/",

    openid: "",
    SAMLResponse: {
      openid: "",
      email: "",
      displayname: "",
      memberOf: "",
      subscribeStatus: "", //用户关注公众号状态
      haveOpenid: false //是否有openid
    },
    userData: {
      name: "",
      memberOf: ""
    }
  },
  mutations: {
    setOpenid(state, id) {
      state.openid = id;
    },
    setSAMLResponse(state, obj) {
      //loading
      state.SAMLResponse = obj;
    },
    setuserData(state, obj) {
      //loading
      state.userData = obj;
    }
  },
  actions: {
    setOpenid(context, id) {
      context.commit("setOpenid", id);
    },
    setSAMLResponse(context, obj) {
      context.commit("setSAMLResponse", obj);
    },
    setuserData(context, obj) {
      context.commit("setuserData", obj);
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js